// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__gytbm","resendInfoText":"OnGoingPaymentBox_resendInfoText__2tApY"};